import PropTypes from "prop-types";
import IosShareOutlinedIcon from "@mui/icons-material/GridOnRounded";
import MDButton from "components/MDButton";

/**
 * DownloadExcelButton
 * White/outline button with a green Excel-style icon, used to replace the
 * old plain "CSV" button across all Reports.
 */
function DownloadExcelButton({ onClick, disabled, label, fullWidth }) {
  return (
    <MDButton
      variant="outlined"
      color="dark"
      size="small"
      fullWidth={fullWidth}
      onClick={onClick}
      disabled={disabled}
      startIcon={<IosShareOutlinedIcon fontSize="small" sx={{ color: "#1D6F42 !important" }} />}
      sx={{
        borderRadius: "8px",
        textTransform: "none",
        fontWeight: 600,
        borderColor: "#E0E0E0",
        color: "#344054",
        "&:hover": {
          borderColor: "#1D6F42",
          backgroundColor: "rgba(29, 111, 66, 0.04)",
        },
      }}
    >
      {label}
    </MDButton>
  );
}

DownloadExcelButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  fullWidth: PropTypes.bool,
};

DownloadExcelButton.defaultProps = {
  disabled: false,
  label: "Download Excel",
  fullWidth: false,
};

export default DownloadExcelButton;